import { render, staticRenderFns } from "./chart-admin.vue?vue&type=template&id=f860cdf2&"
import script from "./chart-admin.vue?vue&type=script&lang=ts&"
export * from "./chart-admin.vue?vue&type=script&lang=ts&"
import style0 from "./chart-admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports